export default __webpack_public_path__ + "static/media/video-about-us-2.010a153d.jpg";